var thumbnails = [];

addEventListener( 'load', function() {
    thumbnails = Array.from( document.getElementsByClassName( 'dropbox__items__item__thumbnail' ) );

    nextThumbnail();
});

function nextThumbnail() {
    var thumbnail = thumbnails.shift();

    if (thumbnail) {
        loadImage(thumbnail);
    }
}

function loadImage(thumbnail)
{
    var image = new Image();
    image.onload = function() {
        thumbnail.style.backgroundImage = 'url(' + this.src + ')';
        nextThumbnail();
    };
    image.src = thumbnail.dataset.image;
}

